import './App.css';
import {useState} from "react";
import TypeSelector from "./Type.Selector";
import {garageInfo} from "./info";
import {ArrowLeft, ArrowRight} from './svg/Arrow';

const selectors = [
    {
        id: 0,
        name: 'Тип панели'
    },
    {
        id: 1,
        name: 'Цветовые решения'
    },
]

function App() {
    const [visualGarage, setVisualGarage] = useState({
        img: './imgs/gofry/S.png',
        color: 'rgb(241, 240, 234)',
        bgImg: './imgs/background/Prestige_body.png'
    })
    const [selector, setSelector] = useState(selectors[0])

    const [selectedGarage1, setSelectedGarage1] = useState(garageInfo[0])
    const [selectedType, setSelectedType] = useState(selectedGarage1.types[0].name)


    function SlideRight() {
        const customGarageSliderDxls = document.getElementById("custom-garage-slider-d");
        if (customGarageSliderDxls) customGarageSliderDxls.scrollLeft -= 220;

    }

    function SlideLeft() {
        const customGarageSliderDxls = document.getElementById("custom-garage-slider-d");
        if (customGarageSliderDxls) customGarageSliderDxls.scrollLeft += 220
    }
    return (
        <div style={{margin: 0}}>
            <div className='img-c-2d'
                 style={{position: 'relative', width: '100%'}}>
                <img src={visualGarage.bgImg}
                alt='Ворота'
                     style={{
                         position: "absolute",
                         objectFit: 'cover',
                         minHeight: '400px',
                         left: 0,
                         margin: 0,
                         top: 0,
                         width: '100%'
                     }}/>
                <div
                    style={{
                        backgroundImage: `url("${visualGarage.img}")`,
                        backgroundColor: visualGarage.color,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        position: 'absolute',
                        backgroundBlendMode: "multiply",
                        top: 0,
                        margin: 0,
                        left: 0,
                        minHeight: '400px',
                        right: 0,
                        bottom: 0,
                        zIndex: -1
                    }}/>
                <span style={{
                    position: "absolute",
                    color: 'white',
                    fontSize: '24px',
                    zIndex: '1',
                    bottom: '5%',
                    left: '5%'
                }}>{selectedGarage1.name}</span>
                <div style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(255, 255, 255, 0) 100%)',
                    padding: '50px',
                    top: 0
                }}/>
                <div style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(255, 255, 255, 0) 100%)',
                    padding: '50px',
                    bottom: 0
                }}/>
            </div>
            <div style={{backgroundColor: '#000', height: '40px', width: '100%'}}>
                <div style={{
                    maxWidth: '1000px',
                    margin: '0 auto',
                    display: 'flex',
                    height: '100%',
                    alignItems: 'center'
                }}> 
                    {selectors.map((s) => (
                       <div style={{marginRight: '30px', marginLeft:'10px'}} key={s.id}>
                         <div style={{position: 'relative'}}>
                            <div style={{
                                cursor: 'pointer',
                                fontSize: '17px',
                                color: s.id === selector.id ? '#fff' : '#b1b1b1'
                            }} onClick={() => setSelector(s)} key={s.id}>
                                {s.name}
                            </div>
                            {s.id === selector.id && (
                                <div className='triangle'
                                     style={{
                                         bottom: '-10px',
                                         left: 0,
                                         right: 0,
                                         margin: 'auto',
                                         position: 'absolute'
                                     }}/>
                            )}
                        </div>
                       </div>
                    ))}
                </div>
            </div>
            <div  style={{maxWidth: '1000px', margin: '0 auto', minHeight: '200px'}}> 
                {selector.id === 0 && (
                    <div style={{display: 'flex', margin: '10px 0', padding: 0, flexWrap: 'wrap'}}>
                        {garageInfo.map((t) => (
                            <div style={{marginRight: '15px'}} key={t.id}
                                 onClick={() => {
                                     setSelectedGarage1(t);
                                     setVisualGarage({...visualGarage, img: t.img});
                                     setSelectedType(t.types[0].name);
                                 }}>
                                <TypeSelector svg={t.svg} name={t.name} highlighted={selectedGarage1.img === t.img}/>
                            </div>
                        ))}
                        <p style={{color: '#b0b0b0', lineHeight: 1.2, fontSize: '14px', paddingTop: '15px'}}><span style={{color: '#e0013f'}}>* </span>Цвет готового изделия может незначительно отличаться от представленного на сайте. Это связано с индивидуальными настройками монитора, а также с особенностями восприятия излучаемого и отражаемого света.</p>

                    </div>
                )}
                {selector.id === 1 && (
                    <div style={{minHeight: '200px'}}>
                       <div className='laptop-c-d'>
                       <ul style={{display: 'flex', listStyle: 'none', padding: 0}}>
                            {selectedGarage1.types.map((i, index) => (
                                <li key={index} onClick={() => setSelectedType(i.name)} style={{
                                    padding: '2px',
                                    cursor: 'pointer',
                                    marginRight: '30px',
                                    fontSize: '17px',
                                    textDecorationLine: selectedType === i.name ? 'underline' : 'none',
                                    textDecorationColor: '#40a629',
                                    textUnderlinePosition: 'under'
                                }}>{i.name}</li>
                            ))}
                        </ul>
                       </div>
                        <select style={{width: '100%', padding: '10px', marginTop: '10px'}} className='m-c-d' onChange={(e) => setSelectedType(e.target.value)}>
                            {selectedGarage1.types.map((i,index) => (
                                <option value={i.name} key={index + 'option'}>{i.name}</option>
                            ))}
                        </select>
                        <div style={{display: 'flex', width: '100%', alignItems: 'center'}}>
                            <div onClick={() => SlideRight()} style={{
                                color: 'black',
                                marginRight: '10px',
                                padding: '10px',
                                cursor: 'pointer',
                                userSelect: 'none',
                                width: '20px',
                                height: '20px'
                            }} className='arrowBtn' role='button' aria-label='Slide left'>
                                <ArrowLeft/>
                            </div>
                            <ul id='custom-garage-slider-d' style={{
                                display: 'flex',
                                listStyle: 'none',
                                overflow: 'hidden',
                                scrollBehavior: 'smooth',
                                whiteSpace: 'nowrap',
                                width: '100%',
                                padding: 0
                            }}>
                                {selectedGarage1.types.find((i) => i.name === selectedType).colors.map((i, index) => (
                                    <li
                                        onClick={() => setVisualGarage({...visualGarage, bgImg: i.bgImg || visualGarage.bgImg, img: i.imgL, color: i.color})}
                                        key={index}
                                        style={{
                                            color: i.imgL === visualGarage.img ? 'rgba(65, 65, 65, 1)' : 'rgba(65, 65, 65, .8)',
                                            padding: '0px 20px',
                                            maxWidth: '100px',
                                            marginTop: '5px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            textAlign: 'center'
                                        }}
                                    >
                                        <div
                                            className={`custom-card-d-d-d ${i.imgL === visualGarage.img && i.color === visualGarage.color ? 'isThisRealCodLol' : ''}`}
                                            style={{
                                                width: '70px',
                                                height: '40px',
                                                borderRadius: '4px',
                                                margin: '0 auto',
                                                background: i.backgroundPreview
                                            }}/>
                                        <span style={{
                                            marginTop: '10px',
                                            fontSize: '14px',
                                            whiteSpace: 'pre-wrap'
                                        }}>{i.name}</span>
                                    </li>
                                ))}
                            </ul>
                            <div onClick={() => SlideLeft()} style={{
                                padding: '10px',
                                width: '20px',
                                marginLeft: '10px',
                                height: '20px',
                                display: 'flex',
                                justifyContent: 'center',
                                userSelect: 'none',
                                alignItems: 'center',
                                cursor: 'pointer'
                            }} className='arrowBtn' role='button' aria-label='Slide right'>
                                <ArrowRight/>
                            </div>
                        </div>
                        <div>
                            {selectedType === 'Стандартные' && (
                               <>
                                    <p style={{fontSize: '17px'}}>
                                        Стандартные цвета имеют близкое соответствие шкале RAL
                                    </p>
                                    <p style={{color: '#838383', fontSize: "14px", paddingTop: '15px'}}>
                                        <span style={{color: '#e0013f'}}>* </span>Цвет доступен только при заказе ворот серии Prestige.
                                    </p>
                                </>
                            )}
                            {selectedType === 'Текстурная цифровая печать' && (
                                <p style={{fontSize: '17px', paddingTop: '15px'}}>Цифровая печать наносится только на ворота серии Prestige.</p>
                            )}
                            <p style={{color: '#b0b0b0', lineHeight: 1.2, fontSize: '14px', paddingTop: '15px'}}><span style={{color: '#e0013f'}}>* </span>Цвет готового изделия может незначительно отличаться от представленного на сайте. Это связано с индивидуальными настройками монитора, а также с особенностями восприятия излучаемого и отражаемого света.</p>
            
                        </div>
                    </div>
                )}

            </div>
            
        </div>
    );
}

export default App;
